var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"typography-content"},[_c('div',{staticClass:"typography-banner-image",style:({ backgroundImage: `url(${_vm.typographyBannerImageSrc})` })}),_c('div',{staticClass:"typography-overlay-image"},[_c('h1',{staticClass:"typography-banner-title"},[_vm._v(_vm._s(_vm.typographyBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }